// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__S6kVT","actionsCol":"EnrolledClinics_actionsCol__2KG6s"};